<template>
  <div class="top-header">

    <!-- 兼容 -->
    <div class="tisshare"></div>

    <div class="top-box">
      <div class="top layui-container layui-clear text1">
        <div class="top-left fl">
          <div class="fl">欢迎来到qdc会员俱乐部！</div>
          <div class="top-member fl "
               v-if="loginshow">
            <a href="http://shop.qdc.com/member/login.html">登录</a>
            <u>|</u>
            <a href="http://shop.qdc.com/member/register.html">注册</a>
          </div>
        </div>
        <div class="top-right fr"
             v-if='loginedshow'>
          <a href="http://shop.qdc.com/member/productorder.html"
             title=""><img src="../assets/order.png"
                 alt="">我的订单</a>
          <u>|</u>
          <a href="http://shop.qdc.com/member/index.html"
             title=""><img src="../assets/members.png"
                 alt="">我的会员专区</a>
        </div>
      </div>
    </div>
    <div class="header-box">
      <div class="header layui-container layui-clear">
        <div class="header-phone fl layui-clear">
          <div class="header-logo fl">
            <a href="http://shop.qdc.com/home/index.html"
               title="">
              <img src="../assets/logo.png"
                   align="">
            </a>
          </div>
          <div :class=" topwidth1==-100 ? 'header-nav-btn fr' : 'header-nav-btn fr open'"
               @click="showNav()">
            <span></span>
            <span></span>
            <span></span>
          </div>

        </div>
        <div class="header-nav fl"
             v-bind:style="{ top:topwidth + '%'}">
          <ul class="nav-list layui-clear">

            <li v-for="(item,index) in tabbarList"
                :key="index"
                class="nav-list-item "
                :class="[item.childenMemu.length>0?'have' : '',
                 item.id==showid?'active':'']"
                @click="clickTabbar(index,item)">

              <a class="nav-one layui-clear">
                <em class="china "> {{item.name}}</em>
                <span class="English">{{item.tag}}</span>
              </a>
              <div class="nav-two-btn"
                   v-show="item.childenMemu.length>0">

                <u class="layui-icon layui-icon-down"></u>
              </div>
              <div class="subnav-box"
                   v-show="item.id==childshow">
                <ul>
                  <li>
                    <a v-for="(items,indexs) in item.childenMemu"
                       :key="indexs"
                       @click="childenMemu(index,item,items,indexs,url)"
                       class="layui-clear"
                       :class="{'active':items.id==childid}">{{items.name}}
                      <u class="layui-icon layui-icon-right"></u>
                    </a>
                  </li>

                </ul>
              </div>
            </li>

          </ul>
          <ul class="nav-member layui-clear"
              v-if="loginshow">
            <li>
              <a href="http://shop.qdc.com/member/login.html"
                 class="layui-btn layui-btn-lg layui-btn-fluid">登录</a>
            </li>
            <li>
              <a href="http://shop.qdc.com/member/register.html"
                 title=""
                 class="layui-btn layui-btn-lg layui-btn-fluid layui-btn-primary">注册</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- <div class="header-height"></div> -->

  </div>
</template>

<script>
import { gettoken, pddl } from '@/api/api'
import { mapActions, mapGetters } from "vuex";
import { getproduct } from '@/api/api'
export default {
  data () {
    return {
      childshow: '',
      showid: 2,
      loginedshow: false,
      loginshow: true,
      url: '',
      showssss: 1,
      productindex: 1,
      childid: 0,
      childshow: 1,
      topwidth: -100,
      topwidth1: -100,
      list: '',
      show: 1,
      childenMemuVisiable: true,
      token: '',
      productid: -1,
      productlistsssss: {},
      PCtopp: true,
      Mtopp: false,
      daohang: true, //显示导航
      flag: false,
      ukey: 0,

    };
  },
  computed: {

    tabbarList: {
      get: function () {
        return this.$store.state.tabbarList
      },
      set: function () {
      }
    },


  },
  created () {
        // localStorage.setItem('newukey', "2dcef772488c31da0902671396c8847e")
    this.gettoken()
    this.ukey = localStorage.getItem('newukey')

    if (localStorage.getItem("showid") != null) {
      this.showid = localStorage.getItem("showid")
    }
    let routerLink = this.$route.path;
    if (routerLink == '/Design' || routerLink == '/DesignColor' || routerLink == '/DesignMake' || routerLink == '/DesignMessage' || routerLink == '/DesignShare') {
      this.showid = 3;
    } else {
      this.showid = 2;
    }
    this.getproductlist();
    this.timer = (setInterval(this.gettoken, 1 * 60 * 1000));
    this.url = this.$route.path
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  mounted () {


  },

  methods: {

    ShowSubnavbox () {
      this.flag = !this.flag;
    },
    showNav () {
      
      this.topwidth1 = -100;
      if (this.topwidth == -100) {
        this.topwidth = 0;
      } else {
        this.topwidth = -100;
      }

    },
    showNav1 () {
      if (this.topwidth1 == -100) {
        this.topwidth1 = 0;
      } else {
        this.topwidth1 = -100;
      }

    },
    //产品子类
    getproductlist () {
      var para = {};
      getproduct(para).then(res => {
        if (res.data.error_code == 200) {
          this.tabbarList[1].childenMemu = res.data.productList
          this.$store.dispatch('ChangetabbarList', this.tabbarList)
        } else {
          console.info("请求失败", err);
        }
      }).catch(err => { console.info("调用失败", err); })
    },

    getpddl () {
      //   let url = window.location.href
      //   let search = url.substr(url.indexOf('?'))
      //   var ukey = getSearchString('ukey', search);
      //   function getSearchString (ukey, Url) {
      //     var str = search;
      //     str = str.substring(1, str.length); // 获取URL中?之后的字符（去掉第一位的问号）
      //     // 以&分隔字符串，获得类似name=xiaoli这样的元素数组
      //     var arr = str.split("&");
      //     var obj = new Object();
      //     // 将每一个数组元素以=分隔并赋给obj对象
      //     for (var i = 0; i < arr.length; i++) {
      //       var tmp_arr = arr[i].split("=");
      //       obj[decodeURIComponent(tmp_arr[0])] = decodeURIComponent(tmp_arr[1]);
      //     }
      //     return obj[ukey];

      //   }

      //   localStorage.setItem('ukey', this.$route.query.ukey)
      //   console.log('data:::' + this.$route.query.ukey)

      var self = this;
      var para = {
        token: sessionStorage.getItem('token'),
        ukey: this.ukey
      };
      // console.log('凭证'+this.ukey);

      pddl(para).then(res => {
        if (res.data.error_code == 200) {
          //   console.log("登录成功", res.data.userid)
          sessionStorage.setItem('userid', res.data.userid)
          localStorage.setItem('newukey', this.ukey)
      
          this.loginshow = !this.loginshow
          this.loginedshow = !this.loginedshow
        }
        res => {
          console.info("调用失败", res);
        };
      });

    },
    gettoken () {
      //   if (localStorage.getItem('newukey') !== null) {
      //     this.ukey = localStorage.getItem('newukey')
      //   } else if (localStorage.getItem('newukey') == 'undefined'|| this.ukey =='undefined') {
      //     this.ukey = 0
      //   } else {
      //     this.ukey = 0
      // //   }
      //    if(this.$route.query.ukey!='undefined'||this.$route.query.ukey!=0){
      //      this.ukey =this.$route.query.ukey

      //  }else if(localStorage.getItem('newukey') !== null){
      //       this.ukey = localStorage.getItem('newukey')
      //       if (localStorage.getItem('newukey') == 'undefined'|| this.ukey =='undefined') {
      //     this.ukey = 0
      //   } 
      //  }else {
      //     this.ukey = 0
      //   }
         
      if (localStorage.getItem('newukey') == '' || localStorage.getItem('newukey') == 'undefined') {
        this.ukey = 0
      } else {
        this.ukey = localStorage.getItem('newukey')
      }
      var self = this;
      var para = {
        account: '155200912321',
        password: '5fe5c90d1972d8f827fad35d2eb0cd8f'
      };
      //   console.log(para);

      gettoken(para).then(res => {
        // console.log("tkoen请求成功112", res.data.data);
        
        this.tokenid = res.data.data
        sessionStorage.setItem('token', res.data.data)
       
        this.getpddl();
        res => {
          console.info("调用失败", res);
        };
      });
    },

    //通过点击按钮显示移动端导航
    showdao () {
      this.daohang = !this.daohang;
    },


    //点击导航
    clickTabbar (index, item, url) {
      this.showid = item.id
      localStorage.setItem('showid', this.showid)
      if (this.childshow == item.id) {
        this.childshow = ''
      } else {
        this.childshow = item.id
      }

      if (item.id == 1) {
        window.location.href = ' http://shop.qdc.com/home/index.html'
      }
      if (item.id == 3) {
        this.$router.push('/Design');

      }
      if (item.id == 5) {
        window.location.href = 'http://shop.qdc.com/member/index.html'
      }
      this.showNav1()
      this.$store.dispatch('ChangetabbarList', this.tabbarList)


    },

    childenMemu (index, item, items, indexs, url) {
      this.productid = items.id;
      this.childid = items.id;
      this.productindex = items.id;
      if (item.id == 2) {
        this.topwidth1 = -100;
        this.$router.push({
          path: '/MixedCellSeries',
          query: {
            productindex: this.productindex,
          }

        });
        // if (this.ukey == 0) {
        //   this.$router.push({
        //     path: '/MixedCellSeries',
        //     query: {
        //       productindex: this.productindex,
        //     }

        //   });
        // } else {
        //   this.$router.push({
        //     path: '/MixedCellSeries',
        //     query: {
        //       productindex: this.productindex,
        //       ukey: this.ukey
        //     }

        //   });
        // }

        //    window.location.reload();
      }
      if (item.id == 4) {
        if (items.id == 1) {
          window.location.href = 'http://shop.qdc.com/service/index/id/20.html'
        }
        if (items.id == 2) {
          window.location.href = 'http://shop.qdc.com/service/seccheck.html'
        }
        if (items.id == 3) {
          window.location.href = 'http://shop.qdc.com/service/proregis.html'
        }
        if (items.id == 4) {
          window.location.href = 'http://shop.qdc.com/service/index/id/21.html'
        }
        if (items.id == 5) {
          window.location.href = 'http://shop.qdc.com/service/index/id/22.html'
        }
      }

      this.$store.dispatch('ChangetabbarList', this.tabbarList)
      this.$store.dispatch('ChangeChildproductlist', items)
      this.showNav()

    },
    // 鼠标移入加入class
    changeActive ($event, index) {
      if (document.body.clientWidth > 1024) {
        this.tabbarList[index].active = "active";
      }
    },
    removeActive ($event, index) {
      if (document.body.clientWidth > 1024) {
        this.tabbarList[index].active = "";
      }
    }

  }
};
</script>

<style >
@import "../../static/newlayout.css";
@import "../../static/layui/css/layui.css";
/* footer */
/* a{ display:block; }
u{ text-decoration:none; } */

/* layui */
/* .body{
    background: url(../assets/bodyback.jpg) repeat center top;
} */
.layui-btn {
  height: auto !important;
  background-color: #0f86e1;
}

.layui-btn-primary {
  color: #0f86e1;
  border-color: #0f86e1;
  background-color: transparent;
}

.layui-btn,
.layui-input,
.layui-select,
.layui-textarea {
  border-radius: 4px;
}

.layui-btn-radius {
  border-radius: 30px;
}

.layui-btn.layui-btn-primary {
  line-height: 36px;
}

.layui-btn-lg.layui-btn-primary {
  line-height: 42px;
}

.layui-btn-sm.layui-btn-primary {
  line-height: 28px;
}

.layui-btn-xs.layui-btn-primary {
  line-height: 20px;
}

.layui-btn + .layui-btn {
  margin-left: 15px;
}

.layui-form-item {
  margin-bottom: 20px;
}

.layui-layer-btn a {
  height: 30px !important;
}

.layui-layer-btn .layui-layer-btn0 {
  float: right;
  border-color: #0f86e1 !important;
  background-color: #0f86e1 !important;
}

.tisshare {
  display: none;
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0px;
  top: 0px;
  z-index: 19999999;
  background: #000;
  opacity: 0.7;
  filter: alpha(opacity=70);
}
.top-header {
  width: 100%;
}
.top-header a {
  display: block;
}
.top-header u {
  text-decoration: none;
}
.top-box {
  background-color: #f5f5f5;
}

/* header */
.top {
  color: #999;
  padding: 10px 15px !important;
}
.top .top-member {
  margin-left: 40px;
}
.top u {
  float: left;
  display: block;
  font-size: 12px;
  margin: 0px 15px;
}
.top a {
  color: #999;
  float: left;
}
.top .top-right img {
  width: 20px;
  float: left;
  margin-right: 5px;
}
.header-box {
  width: 100%;
  /* height: 68px; */
  position: relative;
  background-color: #202020;
  z-index: 999;
}
.header-box.scroll {
  position: fixed;
  top: 0px;
  left: 0px;
  -webkit-transition: all 1s;
  -moz-transition: all 1s;
  -ms-transition: all 1s;
  -o-transition: all 1s;
  transition: all 1s;
  box-shadow: 0px 0px 10px #333;
}
.header-box .header-logo a {
  padding: 13px 0px;
}
.header-box .header-logo img {
  width: 84px;
}
.header-box .header-nav-btn {
  padding: 5px;
  display: none;
  cursor: pointer;
  overflow: hidden;
  margin-top: 15px;
}

.header-box .header-nav-btn span {
  width: 20px;
  height: 2px;
  display: block;
  margin-top: 5px;
  -webkit-transition: all 0.5s;
  -moz-transition: all 0.5s;
  -ms-transition: all 0.5s;
  -o-transition: all 0.5s;
  transition: all 0.5s;
  background-color: #fff;
  -webkit-transform: rotate(0deg) translate3d(0px, 0px, 0);
  -moz-transform: rotate(0deg) translate3d(0px, 0px, 0);
  -ms-transform: rotate(0deg) translate3d(0px, 0px, 0);
  -o-transform: rotate(0deg) translate3d(0px, 0px, 0);
  transform: rotate(0deg) translate3d(0px, 0px, 0);
}
.layui-container {
  height: 100%;
}
.header-box .header-nav-btn span:first-child {
  margin-top: 0px;
}
.header-box .header-nav-btn.open {
  border-color: #0f86e1;
}
.header-box .header-nav-btn.open span {
  position: relative;
  background-color: #0f86e1;
}
.header-box .header-nav-btn.open span:first-child {
  top: 6px;
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(45deg);
}
.header-box .header-nav-btn.open span:nth-child(2) {
  opacity: 0;
}
.header-box .header-nav-btn.open span:nth-child(3) {
  top: -8px;
  -webkit-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
  transform: rotate(-45deg);
}
.header-box .header-nav {
  width: auto;
  margin-left: 5%;
  height: 100%;
}
.header-box .header-nav .nav-list {
  height: 100%;
}
.header-box .header-nav .nav-list-item {
  width: auto;
  float: left;
  position: relative;
  height: 100%;
}
.header-box .header-nav .nav-list-item .nav-one {
  padding: 0px 30px;
}
.header-box .header-nav .nav-list-item .china {
  color: #fff;
  float: left;
  font-size: 18px;
  line-height: 66px;
  border-bottom: 2px solid transparent;
  -webkit-transition: all 0.5s;
  -moz-transition: all 0.5s;
  -ms-transition: all 0.5s;
  -o-transition: all 0.5s;
  transition: all 0.5s;
}
.header-box .header-nav .nav-list-item .English {
  color: #999;
  float: left;
  display: none;
  font-size: 14px;
  line-height: 50px;
  margin-left: 15px;
  text-transform: uppercase;
}
.header-box .header-nav .nav-list-item .nav-two-btn {
  width: 100%;
  height: 50px;
  /* display: none; */
  cursor: pointer;
  line-height: 68px;
  text-align: right;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 2;
}
.header-box .header-nav .nav-list-item .nav-two-btn .layui-icon {
  color: #fff;
  font-size: 12px;
  -webkit-transition: all 0.5s;
  -moz-transition: all 0.5s;
  -ms-transition: all 0.5s;
  -o-transition: all 0.5s;
  transition: all 0.5s;
}
.header-box .header-nav .nav-list-item .nav-two-btn .layui-icon.up {
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
}
.header-box .header-nav .nav-list-item .subnav-box {
  width: auto;
  display: block;
  min-width: 100%;
  background-color: #202020;
  position: absolute;
  top: 68px;
  left: 0px;
  z-index: 4;
}

.header-box .header-nav .nav-list-item .subnav-box a {
  width: 100%;
  color: #d3d3d3;
  font-size: 12px;
  line-height: 36px;
  white-space: nowrap;
  word-break: keep-all;
  padding-left: 30px;
  position: relative;
  padding-right: 60px;
  -webkit-transition: all 0.5s;
  -moz-transition: all 0.5s;
  -ms-transition: all 0.5s;
  -o-transition: all 0.5s;
  transition: all 0.5s;
  background-color: transparent;
}
.header-box .header-nav .nav-list-item .subnav-box a .layui-icon {
  color: #fff;
  display: none;
  font-size: 12px;
  position: absolute;
  top: 0px;
  right: 15px;
}
.header-box .header-nav .nav-list-item .subnav-box a.active {
  color: #fff;
  background-color: #0f86e1;
}
.header-box .header-nav .nav-list-item .subnav-box a.active .layui-icon {
  display: block;
}
.header-box .header-nav .nav-list-item.have {
  margin-right: 20px;
}
.header-box .header-nav .nav-list-item.have .nav-two-btn {
  display: block;
}
.header-box .header-nav .nav-list-item.active .English {
  color: #0f86e1;
}
.header-box .header-nav .nav-list-item.active .china {
  color: #0f86e1;
  border-bottom-color: #0f86e1;
}
.header-box .header-nav .nav-list-item.active .nav-two-btn .layui-icon {
  color: #0f86e1;
}
.header-box .header-nav .nav-member {
  width: 100%;
  display: none;
  position: absolute;
  left: 0px;
  bottom: 0px;
}
.header-box .header-nav .nav-member li {
  width: 50%;
  float: left;
}
.header-box .header-nav .nav-member .layui-btn {
  border-radius: 0px;
}
@media screen and (min-width: 992px) {
  .layui-btn-primary:hover {
    color: #fff;
    border-color: #0f86e1;
    background-color: #0f86e1;
  }
  .top a:hover {
    color: #0f86e1;
  }
  .header-box .header-nav .nav-list-item:hover .china {
    color: #0f86e1;
  }
  .header-box .header-nav .nav-list-item:hover .nav-two-btn .layui-icon {
    color: #0f86e1;
  }
  .header-box .header-nav .nav-list-item .subnav-box a:hover {
    color: #fff;
    background-color: #0f86e1;
  }
  .header-box .header-nav .nav-list-item .subnav-box a:hover .layui-icon {
    display: block;
  }
}
@media screen and (min-width: 1200px) {
  .layui-container {
    width: 1200px;
  }
}
@media screen and (max-width: 991px) {
  /* header */
  .top {
    font-size: 12px;
    padding: 5px 15px;
  }
  .header-box .header-logo img {
    width: 58px;
  }
  .header-box .header-nav .nav-list-item .china {
    font-size: 16px;
    line-height: 53px;
  }
  .header-box .header-nav .nav-list-item .nav-two-btn {
    line-height: 55px;
  }
}
@media screen and (max-width: 767px) {
  .heightF {
    width: 100%;
    height: 50px;
  }
  .bread,
  .page {
    display: none;
  }
  .loadMore {
    display: block;
  }

  .text1 {
    font-size: 12px;
  }
  /* header */
  .top-box {
    display: none;
  }
  .header-box .header-nav-btn,
  .header-box .header-nav .nav-member {
    display: block;
    height: 38px;
  }
  .top-header {
    width: 100%;
    height: 55px;
  }
  .header-height {
    width: 100%;
    height: 55px;
    display: block;
  }
  .header-box {
    position: fixed;
    top: 0px;
    left: 0px;
    box-shadow: 0px 0px 10px #333;
  }
  .header-box .header {
    padding: 0px;
  }
  .header-box .header-phone {
    width: 100%;
    float: none;
    padding: 0px 15px;
    background-color: #202020;
    position: relative;
    z-index: 100;
    display: block;
  }
  .header-box .header-nav {
    width: 100%;
    height: 100%;
    margin-left: 0px;
    padding-top: 80px;
    padding-bottom: 50px;
    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
    -ms-transition: all 0.5s;
    -o-transition: all 0.5s;
    transition: all 0.5s;
    background-color: #202020;
    position: fixed;
    top: -100%;
    left: 0px;
    z-index: 10;
  }
  .header-box .header-nav .nav-list {
    width: 100%;
    height: 100%;
    overflow-y: scroll;
  }
  .header-box .header-nav .nav-list-item {
    width: 100%;
    float: none;
    height: auto;
  }
  .header-box .header-nav .nav-list-item .nav-one {
    padding: 0px 15px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }
  .header-box .header-nav .nav-list-item .china {
    font-size: 14px;
    line-height: 50px;
    border-bottom: none;
  }
  .header-box .header-nav .nav-list-item .English {
    display: block;
  }
  .header-box .header-nav .nav-list-item .nav-two-btn {
    line-height: 50px;
    padding-right: 20px;
  }
  .header-box .header-nav .nav-list-item .subnav-box {
    top: 0px;
    width: 100%;
    margin-left: 0px;
    padding-top: 5px;
    position: relative;
    /* display: none; */
    display: block;
  }
  .header-box .header-nav .nav-list-item .subnav-box a .layui-icon {
    display: block;
    padding-right: 5px;
  }
  .layui-container {
    width: 100%;

    padding: 0px 10px;
  }
}
@media screen and (max-width: 481px) {
  /* layui */
  .layui-btn {
    height: auto !important;
    background-color: #0f86e1 !important;
  }
  .layui-btn-primary {
    color: #0f86e1 !important;
    border-color: #0f86e1 !important;
    background-color: transparent !important;
  }
  .layui-btn {
    line-height: 32px;
  }
  .layui-btn-lg {
    line-height: 38px !important;
  }
  .layui-btn-sm {
    line-height: 24px;
  }
  .layui-btn-xs {
    line-height: 18px;
  }
  .layui-btn.layui-btn-primary {
    line-height: 30px;
  }
  .layui-btn-lg.layui-btn-primary {
    line-height: 36px;
  }
  .layui-btn-sm.layui-btn-primary {
    line-height: 22px;
  }
  .layui-btn-xs.layui-btn-primary {
    line-height: 16px;
  }
  .yzm {
    line-height: 38px;
  }
}

/*# sourceMappingURL=public.css.map */
</style>


// WEBPACK FOOTER //
// src/components/pageheader.vue